import { useMemo } from "react";

import { ListProcessingStatus, ListStatus } from "@/enum/list.enum";
import { listSelector } from "@/pages/Private/redux/list/list.slice";
import { User } from "@/pages/Public/pages/Login/schema/login";
import { useAppSelector } from "@/redux/hooks";
import { authSelector } from "@/pages/Public/redux/auth.slice";
import { Email, isEmailLoggedOut } from "@/pages/Private/pages/Account/schema/email";
import {
	isLinkedinDisconnectedStatus,
	isSalesNavigatorDisconnectedStatus,
} from "@/pages/Private/pages/Account/schema/unipile";

export const useTopbarInfo = () => {
	const { user } = useAppSelector(authSelector);

	const { lists } = useAppSelector(listSelector);

	const processingLists = useMemo(() => {
		return lists.filter(
			(list) =>
				list.processingStatus === ListProcessingStatus.PROCESSING &&
				list.status === ListStatus.ACTIVE
		);
	}, [lists]);

	const initialUserAsString = localStorage.getItem("initialUser");

	let initialUser: { user: User } | null = null;

	if (initialUserAsString) {
		initialUser = JSON.parse(initialUserAsString) as { user: User };
	}

	const loggedOutEmails = useMemo(() => {
		return user?.emails?.filter((email: Email) => isEmailLoggedOut(email.status));
	}, [user?.emails]);

	// Only a previously-connected account that is now logged out (`CREDENTIALS`) should see the
	// "reconnect" warning. A user who never connected LinkedIn has no such unipile session, so the
	// reconnect prompt must not show for them.
	const isLinkedinNotConnected =
		user?.linkedinAllowed && isLinkedinDisconnectedStatus(user?.unipile?.status);
	const isSalesNavigatorNotConnected =
		user?.hasLiSn && isSalesNavigatorDisconnectedStatus(user?.unipile?.status);

	const higherTopbar =
		isLinkedinNotConnected ||
		initialUser ||
		processingLists.length > 0 ||
		isSalesNavigatorNotConnected ||
		(loggedOutEmails && loggedOutEmails?.length > 0);

	return {
		processingLists,
		initialUser,
		isLinkedinNotConnected,
		isSalesNavigatorNotConnected,
		higherTopbar,
		user,
		loggedOutEmails,
	};
};
